import { Routes } from "@angular/router";
import { AuthGuard } from "@core/guard/auth.guard";

export const routes: Routes = [
  { path: "", redirectTo: "/authentication/signin", pathMatch: "full" },
  {
    path: 'Home',
    //component:MainLayoutComponent,
    loadChildren: () => import("./home/home.routes").then(m => m.HomeRoutes),
    canActivate: [AuthGuard]
  },
  {
    path: "authentication",
    loadComponent: () => import('@theme/app-layout/auth-layout/auth-layout.component').then((c) => c.AuthLayoutComponent),
    loadChildren: () =>
      import("./authentication/authentication-routes").then(
        (m) => m.AuthnticationRoutes
      ),
  },
  {
    path: "**",
    loadComponent: () => import("./authentication/page404/page404.component").then((c) => c.Page404Component)
  },
];